import React from "react";
import styles from "../styles/platos.module.css";
import { fmt } from "../domain/platosFormat";
import { isPlatoEnEvento } from "../domain/platosRules";

export default function PlatoItem({ plato, open, onToggle, onEdit, onDelete }) {
    const alergs = plato?.alergenos || [];
    const resumen = `${alergs.length} alérgeno(s)`;
    const blocked = isPlatoEnEvento(plato);

    return (
        <article className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}>
            <button
                type="button"
                className={styles["accordion-header"]}
                onClick={onToggle}
                aria-expanded={open}
                aria-controls={`plato-body-${plato.id}`}
            >
                <div className={styles["accordion-title"]}>
                    <strong>{plato.nombre}</strong>
                    <span className={styles.muted}>— {resumen}</span>
                </div>
                <span className={styles.chevron} aria-hidden>▾</span>
            </button>

            <div id={`plato-body-${plato.id}`} className={styles["accordion-body"]}>
                <div className={styles["item-row"]}>
                    <div className={styles["grid-2"]}>
                        <div className={styles.field}>
                            <label className={styles.label}>Descripción</label>
                            <div className={styles.muted}>{fmt.text(plato.descripcion)}</div>
                        </div>
                        <div className={styles.field}>
                            <label className={styles.label}>Alérgenos</label>
                            {alergs.length === 0 ? (
                                <span className={`${styles.pill} ${styles.ghost}`}>Ninguno</span>
                            ) : (
                                <ul className={styles.chips}>
                                    {alergs.map((a) => (
                                        <li key={a.id} className={styles.chip}>
                                            {a.alergenoDescripcion || a.alergeno}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div className={styles["item-actions"]}>
                        <button className={styles.btn} type="button" onClick={onEdit}>Editar</button>
                        <button
                            className={`${styles.btn} ${styles.danger}`}
                            type="button"
                            onClick={onDelete}
                            disabled={blocked}
                            title={blocked ? "No se puede eliminar: el plato está asignado a un evento." : "Eliminar"}
                        >
                            Eliminar
                        </button>
                    </div>
                </div>
            </div>
        </article>
    );
}
